import React from "react";
import styled from "styled-components";

export const PromptText = styled.p`
  font-family: montserrat;
  font-weight: bold;
  text-align: center;
  padding: 0 8px;
`;
